import actions from "./actions";

const betriebsanweisungModule = {
  actions,
};

export default betriebsanweisungModule;
